import React from "react";
import { ReactComponent as Add } from "../../../assets/svg/icons/add.svg";
import { ReactComponent as AddChecklist } from "../../../assets/svg/icons/add-checklist.svg";
import { ReactComponent as AddComment } from "../../../assets/svg/icons/add-comment.svg";
import { ReactComponent as ArrowRight } from "../../../assets/svg/icons/arrow-right.svg";
import { ReactComponent as Barcode } from "../../../assets/svg/icons/barcode.svg";
import { ReactComponent as Bell } from "../../../assets/svg/icons/bell.svg";
import { ReactComponent as Calendar } from "../../../assets/svg/icons/calendar.svg";
import { ReactComponent as CalendarCheck } from "../../../assets/svg/icons/calendar-check.svg";
import { ReactComponent as Cart } from "../../../assets/svg/icons/cart.svg";
import { ReactComponent as Chart } from "../../../assets/svg/icons/chart.svg";
import { ReactComponent as CartWeighted } from "../../../assets/svg/icons/cart-weighted.svg";
import { ReactComponent as Checkmark } from "../../../assets/svg/icons/checkmark.svg";
import { ReactComponent as CheckmarkThin } from "../../../assets/svg/icons/checkmark-thin.svg";
import { ReactComponent as ChevronLeft } from "../../../assets/svg/icons/chevron-left.svg";
import { ReactComponent as ChevronRight } from "../../../assets/svg/icons/chevron-right.svg";
import { ReactComponent as ChevronSmallDown } from "../../../assets/svg/icons/chevron-small-down.svg";
import { ReactComponent as ChevronSmallLeft } from "../../../assets/svg/icons/chevron-small-left.svg";
import { ReactComponent as ChevronSmallUp } from "../../../assets/svg/icons/chevron-small-up.svg";
import { ReactComponent as Clipboard } from "../../../assets/svg/icons/clipboard.svg";
import { ReactComponent as Clock } from "../../../assets/svg/icons/clock.svg";
import { ReactComponent as Close } from "../../../assets/svg/icons/close.svg";
import { ReactComponent as Construction } from "../../../assets/svg/icons/construction.svg";
import { ReactComponent as Contact } from "../../../assets/svg/icons/contact.svg";
import { ReactComponent as ContactOutline } from "../../../assets/svg/icons/contact-outline.svg";
import { ReactComponent as CogwheelStroke } from "../../../assets/svg/icons/cogwheel-stroke.svg";
import { ReactComponent as Comment } from "../../../assets/svg/icons/comment.svg";
import { ReactComponent as Cookie } from "../../../assets/svg/icons/cookie.svg";
import { ReactComponent as CustomerService } from "../../../assets/svg/icons/customer-service.svg";
import { ReactComponent as Dankort } from "../../../assets/svg/icons/dankort.svg";
import { ReactComponent as DankortWrapped } from "../../../assets/svg/icons/dankort-wrapped.svg";
import { ReactComponent as Delivery } from "../../../assets/svg/icons/delivery.svg";
import { ReactComponent as Document } from "../../../assets/svg/icons/document.svg";
import { ReactComponent as DocumentOutline } from "../../../assets/svg/icons/document-outline.svg";
import { ReactComponent as DollyStroke } from "../../../assets/svg/icons/dolly-stroke.svg";
import { ReactComponent as EconomyPlaceholder } from "../../../assets/svg/icons/economy-placeholder.svg";
import { ReactComponent as ExclamationMark } from "../../../assets/svg/icons/exclamation-mark.svg";
import { ReactComponent as Expand } from "../../../assets/svg/icons/expand.svg";
import { ReactComponent as Ellipsis } from "../../../assets/svg/icons/ellipsis.svg";
import { ReactComponent as ExternalLink } from "../../../assets/svg/icons/external-link.svg";
import { ReactComponent as Facebook } from "../../../assets/svg/icons/some-facebook-circle.svg";
import { ReactComponent as FarmInTime } from "../../../assets/svg/icons/farm-in-time.svg";
import { ReactComponent as FileUpload } from "../../../assets/svg/icons/file-upload.svg";
import { ReactComponent as FilterTool } from "../../../assets/svg/icons/filter-tool.svg";
import { ReactComponent as FormCheck } from "../../../assets/svg/icons/form-check.svg";
import { ReactComponent as FormCheckWeighted } from "../../../assets/svg/icons/form-check-weighted.svg";
import { ReactComponent as FormSubmit } from "../../../assets/svg/icons/form-submit.svg";
import { ReactComponent as Globe } from "../../../assets/svg/icons/globe.svg";
import { ReactComponent as Handshake } from "../../../assets/svg/icons/handshake.svg";
import { ReactComponent as Harvest } from "../../../assets/svg/icons/harvest.svg";
import { ReactComponent as Harvester } from "../../../assets/svg/icons/harvester.svg";
import { ReactComponent as HeartOutline } from "../../../assets/svg/icons/heart_outline.svg";
import { ReactComponent as HeartSolid } from "../../../assets/svg/icons/heart_solid.svg";
import { ReactComponent as Info } from "../../../assets/svg/icons/info.svg";
import { ReactComponent as Instagram } from "../../../assets/svg/icons/some-instagram-circle.svg";
import { ReactComponent as Invoice } from "../../../assets/svg/icons/faktura.svg";
import { ReactComponent as Leaf } from "../../../assets/svg/icons/leaf.svg";
import { ReactComponent as Letter } from "../../../assets/svg/icons/letter.svg";
import { ReactComponent as LetterOutlined } from "../../../assets/svg/icons/letter-outlined.svg";
import { ReactComponent as LinkedIn } from "../../../assets/svg/icons/some-linkedin-circle.svg";
import { ReactComponent as MagnifyingGlass } from "../../../assets/svg/icons/magnifying-glass.svg";
import { ReactComponent as Man } from "../../../assets/svg/icons/man.svg";
import { ReactComponent as MasterCard } from "../../../assets/svg/icons/mastercard.svg";
import { ReactComponent as MasterCardWrapped } from "../../../assets/svg/icons/mastercard-wrapped.svg";
import { ReactComponent as MenuBurger } from "../../../assets/svg/icons/menu-burger.svg";
import { ReactComponent as MenuDots } from "../../../assets/svg/icons/menu-dots.svg";
import { ReactComponent as Minus } from "../../../assets/svg/icons/minus.svg";
import { ReactComponent as Mobile } from "../../../assets/svg/icons/mobile.svg";
import { ReactComponent as MobilePay } from "../../../assets/svg/icons/mobile-pay.svg";
import { ReactComponent as MobilePayWrapped } from "../../../assets/svg/icons/mobile-pay-wrapped.svg";
import { ReactComponent as Pdf } from "../../../assets/svg/icons/pdf.svg";
import { ReactComponent as Pen } from "../../../assets/svg/icons/pen.svg";
import { ReactComponent as Pencil } from "../../../assets/svg/icons/pencil.svg";
import { ReactComponent as Phone } from "../../../assets/svg/icons/phone.svg";
import { ReactComponent as PhoneOutline } from "../../../assets/svg/icons/phone-outline.svg";
import { ReactComponent as Pin } from "../../../assets/svg/icons/pin.svg";
import { ReactComponent as DanishAgroLogoPin } from "../../../assets/svg/icons/danish-agro-logo-pin.svg";
import { ReactComponent as PlantHand } from "../../../assets/svg/icons/planthand.svg";
import { ReactComponent as Play } from "../../../assets/svg/icons/play.svg";
import { ReactComponent as Profile } from "../../../assets/svg/icons/profile.svg";
import { ReactComponent as QuantityDiscount } from "../../../assets/svg/icons/quantity-discount.svg";
import { ReactComponent as Question } from "../../../assets/svg/icons/question.svg";
import { ReactComponent as Quote } from "../../../assets/svg/icons/quote.svg";
import { ReactComponent as Remove } from "../../../assets/svg/icons/remove.svg";
import { ReactComponent as Rosette } from "../../../assets/svg/icons/rosette.svg";
import { ReactComponent as RotateDevice } from "../../../assets/svg/icons/rotate-device.svg";
import { ReactComponent as ScrollHorizontal } from "../../../assets/svg/icons/scroll-horizontal.svg";
import { ReactComponent as Swipe } from "../../../assets/svg/icons/swipe.svg";
import { ReactComponent as ScrollLeftRight } from "../../../assets/svg/icons/scrollLeftRight.svg";
import { ReactComponent as SignOut } from "../../../assets/svg/icons/sign-out.svg";
import { ReactComponent as SearchOutline } from "../../../assets/svg/icons/search-outline.svg";
import { ReactComponent as StatisticKvantum } from "../../../assets/svg/icons/statastics_kvantum.svg";
import { ReactComponent as StatisticBuy } from "../../../assets/svg/icons/statastics_buy.svg";
import { ReactComponent as StatisticSale } from "../../../assets/svg/icons/statastics_sale.svg";
import { ReactComponent as StatisticsAmount } from "../../../assets/svg/icons/statastics_amount.svg";
import { ReactComponent as Star } from "../../../assets/svg/icons/star.svg";
import { ReactComponent as StarSolid } from "../../../assets/svg/icons/star-solid.svg";
import { ReactComponent as Support } from "../../../assets/svg/icons/support.svg";
import { ReactComponent as Text } from "../../../assets/svg/icons/text.svg";
import { ReactComponent as TikTok } from "../../../assets/svg/icons/tiktok.svg";
import { ReactComponent as Tractor } from "../../../assets/svg/icons/tractor.svg";
import { ReactComponent as Trash } from "../../../assets/svg/icons/trash.svg";
import { ReactComponent as TriangleSmallDown } from "../../../assets/svg/icons/triangle-small-down.svg";
import { ReactComponent as Truck } from "../../../assets/svg/icons/truck.svg";
import { ReactComponent as TruckOutline } from "../../../assets/svg/icons/truck-outline.svg";
import { ReactComponent as Twitter } from "../../../assets/svg/icons/some-twitter-circle.svg";
import { ReactComponent as UserCrown } from "../../../assets/svg/icons/user-crown.svg";
import { ReactComponent as UserLoggedIn } from "../../../assets/svg/icons/user-logged-in.svg";
import { ReactComponent as UserLoggedInWeighted } from "../../../assets/svg/icons/user-logged-in-weighted.svg";
import { ReactComponent as UserLoggedOut } from "../../../assets/svg/icons/user-logged-out.svg";
import { ReactComponent as UserLoggedOutWeighted } from "../../../assets/svg/icons/user-logged-out-weighted.svg";
import { ReactComponent as Van } from "../../../assets/svg/icons/van.svg";
import { ReactComponent as Visa } from "../../../assets/svg/icons/visa-card.svg";
import { ReactComponent as VisaWrapped } from "../../../assets/svg/icons/visa-card-wrapped.svg";
import { ReactComponent as WarningSign } from "../../../assets/svg/icons/warning-sign.svg";
import { ReactComponent as YouTube } from "../../../assets/svg/icons/some-youtube-circle.svg";
import { ReactComponent as Zoom } from "../../../assets/svg/icons/zoom.svg";
import { ReactComponent as ZoomWeighted } from "../../../assets/svg/icons/zoom-weighted.svg";
import { ReactComponent as X } from "../../../assets/svg/icons/some-x-circle.svg";
import { DA_IconNames } from "./Icon.component";

const ActualIcon = ({ name }: { name: DA_IconNames }) => {
    let ReturnIcon = React.Fragment;

    switch (name) {
        case DA_IconNames.Add:
            ReturnIcon = Add;
            break;
        case DA_IconNames.AddChecklist:
            ReturnIcon = AddChecklist;
            break;
        case DA_IconNames.AddComment:
            ReturnIcon = AddComment;
            break;
        case DA_IconNames.ArrowRight:
            ReturnIcon = ArrowRight;
            break;
        case DA_IconNames.Barcode:
            ReturnIcon = Barcode;
            break;
        case DA_IconNames.Bell:
            ReturnIcon = Bell;
            break;
        case DA_IconNames.Calendar:
            ReturnIcon = Calendar;
            break;
        case DA_IconNames.CalendarCheck:
            ReturnIcon = CalendarCheck;
            break;
        case DA_IconNames.Cart:
            ReturnIcon = Cart;
            break;
        case DA_IconNames.Chart:
            ReturnIcon = Chart;
            break;
        case DA_IconNames.CartWeighted:
            ReturnIcon = CartWeighted;
            break;
        case DA_IconNames.CogWheel:
            ReturnIcon = CogwheelStroke;
            break;
        case DA_IconNames.Comment:
            ReturnIcon = Comment;
            break;
        case DA_IconNames.Checkmark:
            ReturnIcon = Checkmark;
            break;
        case DA_IconNames.CheckmarkThin:
            ReturnIcon = CheckmarkThin;
            break;
        case DA_IconNames.ChevronLeft:
            ReturnIcon = ChevronLeft;
            break;
        case DA_IconNames.ChevronRight:
            ReturnIcon = ChevronRight;
            break;
        case DA_IconNames.ChevronSmallDown:
            ReturnIcon = ChevronSmallDown;
            break;
        case DA_IconNames.ChevronSmallLeft:
            ReturnIcon = ChevronSmallLeft;
            break;
        case DA_IconNames.CheckListBoard:
            ReturnIcon = FormCheck;
            break;
        case DA_IconNames.ChevronSmallUp:
            ReturnIcon = ChevronSmallUp;
            break;
        case DA_IconNames.Close:
            ReturnIcon = Close;
            break;
        case DA_IconNames.CogwheelStroke:
            ReturnIcon = CogwheelStroke;
            break;
        case DA_IconNames.Construction:
            ReturnIcon = Construction;
            break;
        case DA_IconNames.Contact:
            ReturnIcon = Contact;
            break;
        case DA_IconNames.ContactOutline:
            ReturnIcon = ContactOutline;
            break;
        case DA_IconNames.Cookie:
            ReturnIcon = Cookie;
            break;
        case DA_IconNames.CustomerService:
            ReturnIcon = CustomerService;
            break;
        case DA_IconNames.Dankort:
            ReturnIcon = Dankort;
            break;
        case DA_IconNames.DankortWrapped:
            ReturnIcon = DankortWrapped;
            break;
        case DA_IconNames.Delivery:
            ReturnIcon = Delivery;
            break;
        case DA_IconNames.DeliveryTrolley:
            ReturnIcon = DollyStroke;
            break;
        case DA_IconNames.DeliveryTruck:
            ReturnIcon = Delivery;
            break;
        case DA_IconNames.Document:
            ReturnIcon = Document;
            break;
        case DA_IconNames.DocumentOutline:
            ReturnIcon = DocumentOutline;
            break;
        case DA_IconNames.DollyStroke:
            ReturnIcon = DollyStroke;
            break;
        case DA_IconNames.EconomyPlaceholder:
            ReturnIcon = EconomyPlaceholder;
            break;
        case DA_IconNames.EmailEnvelope:
            ReturnIcon = LetterOutlined;
            break;
        case DA_IconNames.ExclamationMark:
            ReturnIcon = ExclamationMark;
            break;
        case DA_IconNames.ExternalLink:
            ReturnIcon = ExternalLink;
            break;
        case DA_IconNames.Expand:
            ReturnIcon = Expand;
            break;
        case DA_IconNames.Ellipsis:
            ReturnIcon = Ellipsis;
            break;
        case DA_IconNames.Facebook:
            ReturnIcon = Facebook;
            break;
        case DA_IconNames.FarmInTime:
            ReturnIcon = FarmInTime;
            break;
        case DA_IconNames.FilterTool:
            ReturnIcon = FilterTool;
            break;
        case DA_IconNames.FileUpload:
            ReturnIcon = FileUpload;
            break;
        case DA_IconNames.FormSubmit:
            ReturnIcon = FormSubmit;
            break;
        case DA_IconNames.FormCheck:
            ReturnIcon = FormCheck;
            break;
        case DA_IconNames.FormCheckWeighted:
            ReturnIcon = FormCheckWeighted;
            break;
        case DA_IconNames.Globe:
            ReturnIcon = Globe;
            break;
        case DA_IconNames.Handshake:
            ReturnIcon = Handshake;
            break;
        case DA_IconNames.Harvest:
            ReturnIcon = Harvest;
            break;
        case DA_IconNames.Harvester:
            ReturnIcon = Harvester;
            break;
        case DA_IconNames.HarvestMachine:
            ReturnIcon = Harvester;
            break;
        case DA_IconNames.HarvestStraw:
            ReturnIcon = Harvest;
            break;
        case DA_IconNames.HeartOutline:
            ReturnIcon = HeartOutline;
            break;
        case DA_IconNames.HeartSolid:
            ReturnIcon = HeartSolid;
            break;
        case DA_IconNames.Info:
            ReturnIcon = Info;
            break;
        case DA_IconNames.Instagram:
            ReturnIcon = Instagram;
            break;
        case DA_IconNames.Invoice:
            ReturnIcon = Invoice;
            break;
        case DA_IconNames.Leaf:
            ReturnIcon = Leaf;
            break;
        case DA_IconNames.Letter:
            ReturnIcon = Letter;
            break;
        case DA_IconNames.LetterOutlined:
            ReturnIcon = LetterOutlined;
            break;
        case DA_IconNames.LinkedIn:
            ReturnIcon = LinkedIn;
            break;
        case DA_IconNames.LocationPin:
            ReturnIcon = Pin;
            break;
        case DA_IconNames.MagnifyingGlass:
            ReturnIcon = MagnifyingGlass;
            break;
        case DA_IconNames.Man:
            ReturnIcon = Man;
            break;
        case DA_IconNames.MasterCard:
            ReturnIcon = MasterCard;
            break;
        case DA_IconNames.MasterCardWrapped:
            ReturnIcon = MasterCardWrapped;
            break;
        case DA_IconNames.MenuBurger:
            ReturnIcon = MenuBurger;
            break;
        case DA_IconNames.MenuDots:
            ReturnIcon = MenuDots;
            break;
        case DA_IconNames.Minus:
            ReturnIcon = Minus;
            break;
        case DA_IconNames.Mobile:
            ReturnIcon = Mobile;
            break;
        case DA_IconNames.MobilePay:
            ReturnIcon = MobilePay;
            break;
        case DA_IconNames.MobilePayWrapped:
            ReturnIcon = MobilePayWrapped;
            break;
        case DA_IconNames.Pdf:
            ReturnIcon = Pdf;
            break;
        case DA_IconNames.PdfDocument:
            ReturnIcon = Pdf;
            break;
        case DA_IconNames.Pen:
            ReturnIcon = Pen;
            break;
        case DA_IconNames.Pencil:
            ReturnIcon = Pencil;
            break;
        case DA_IconNames.Phone:
            ReturnIcon = Phone;
            break;
        case DA_IconNames.PhoneOutline:
            ReturnIcon = PhoneOutline;
            break;
        case DA_IconNames.PlantHand:
            ReturnIcon = PlantHand;
            break;
        case DA_IconNames.Play:
            ReturnIcon = Play;
            break;
        case DA_IconNames.Profile:
            ReturnIcon = Profile;
            break;
        case DA_IconNames.QuantityDiscount:
            ReturnIcon = QuantityDiscount;
            break;
        case DA_IconNames.Question:
            ReturnIcon = Question;
            break;
        case DA_IconNames.Quote:
            ReturnIcon = Quote;
            break;
        case DA_IconNames.Remove:
            ReturnIcon = Remove;
            break;
        case DA_IconNames.RotateDevice:
            ReturnIcon = RotateDevice;
            break;
        case DA_IconNames.ScrollHorizontal:
            ReturnIcon = ScrollHorizontal;
            break;
        case DA_IconNames.Swipe:
            ReturnIcon = Swipe;
            break;
        case DA_IconNames.ScrollLeftRight:
            ReturnIcon = ScrollLeftRight;
            break;
        case DA_IconNames.SearchOutline:
            ReturnIcon = SearchOutline;
            break;
        case DA_IconNames.SmartPhone:
            ReturnIcon = Mobile;
            break;
        case DA_IconNames.SignOut:
            ReturnIcon = SignOut;
            break;
        case DA_IconNames.ShoppingBasket:
            ReturnIcon = Cart;
            break;
        case DA_IconNames.Star:
            ReturnIcon = Star;
            break;
        case DA_IconNames.StarSolid:
            ReturnIcon = StarSolid;
            break;
        case DA_IconNames.StatisticKvantum:
            ReturnIcon = StatisticKvantum;
            break;
        case DA_IconNames.StatisticBuy:
            ReturnIcon = StatisticBuy;
            break;
        case DA_IconNames.StatisticSale:
            ReturnIcon = StatisticSale;
            break;
        case DA_IconNames.StatisticsAmount:
            ReturnIcon = StatisticsAmount;
            break;
        case DA_IconNames.Support:
            ReturnIcon = Support;
            break;
        case DA_IconNames.Text:
            ReturnIcon = Text;
            break;
        case DA_IconNames.TikTok:
            ReturnIcon = TikTok;
            break;
        case DA_IconNames.Tractor:
            ReturnIcon = Tractor;
            break;
        case DA_IconNames.Trash:
            ReturnIcon = Trash;
            break;
        case DA_IconNames.TriangleSmallDown:
            ReturnIcon = TriangleSmallDown;
            break;
        case DA_IconNames.Truck:
            ReturnIcon = Truck;
            break;
        case DA_IconNames.TruckOutline:
            ReturnIcon = TruckOutline;
            break;
        case DA_IconNames.Twitter:
            ReturnIcon = Twitter;
            break;
        case DA_IconNames.UserCrown:
            ReturnIcon = UserCrown;
            break;
        case DA_IconNames.UserLoggedIn:
            ReturnIcon = UserLoggedIn;
            break;
        case DA_IconNames.UserLoggedInWeighted:
            ReturnIcon = UserLoggedInWeighted;
            break;
        case DA_IconNames.UserLoggedOut:
            ReturnIcon = UserLoggedOut;
            break;
        case DA_IconNames.UserLoggedOutWeighted:
            ReturnIcon = UserLoggedOutWeighted;
            break;
        case DA_IconNames.WarningSign:
            ReturnIcon = WarningSign;
            break;
        case DA_IconNames.Van:
            ReturnIcon = Van;
            break;
        case DA_IconNames.Visa:
            ReturnIcon = Visa;
            break;
        case DA_IconNames.VisaWrapped:
            ReturnIcon = VisaWrapped;
            break;
        case DA_IconNames.Zoom:
            ReturnIcon = Zoom;
            break;
        case DA_IconNames.ZoomWeighted:
            ReturnIcon = ZoomWeighted;
            break;
        case DA_IconNames.YouTube:
            ReturnIcon = YouTube;
            break;
        case DA_IconNames.Clock:
            ReturnIcon = Clock;
            break;
        case DA_IconNames.Clipboard:
            ReturnIcon = Clipboard;
            break;
        case DA_IconNames.Pin:
            ReturnIcon = Pin;
            break;
        case DA_IconNames.DanishAgroLogoPin:
            ReturnIcon = DanishAgroLogoPin;
            break;
        case DA_IconNames.Rosette:
            ReturnIcon = Rosette;
            break;
        case DA_IconNames.X:
            ReturnIcon = X;
            break;
    }

    return <ReturnIcon />;
};

export default ActualIcon;
